import { render, staticRenderFns } from "./attitude.vue?vue&type=template&id=215b1958&scoped=true&"
import script from "./attitude.vue?vue&type=script&lang=js&"
export * from "./attitude.vue?vue&type=script&lang=js&"
import style0 from "./attitude.vue?vue&type=style&index=0&id=215b1958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b1958",
  null
  
)

export default component.exports